<template>
  <CampaignsListCard v-bind="{ campaigns, routeToCampaign }" />
</template>

<script>
import CampaignsListCard from "@/components/CampaignsListCard";
import { mapState } from "vuex";

export default {
  components: {
    CampaignsListCard,
  },
  computed: {
    ...mapState("campaigns", { campaigns: "content" }),
  },
  methods: {
    routeToCampaign(id) {
      this.$router.push({ name: "campaign", params: { id } });
    },
  },
};
</script>
